import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import * as oauth from 'oauth';
import { ExternalLink } from '../../../../common/ExternalLink';

const OrganizationsAbsent = ({ handleLogout }) => {
  const { email } = oauth.getCurrentUser() || {};

  return (
    <Alert className="content-alert" variant="warning">
      <p className="mt-2"><strong>We are unable to locate an available Google Organization.</strong></p>
      <ul>
        <li>
          Your Google account
          {email && (
          <em>
            (
            { email }
            )
          </em>
          )}
          {' '}
          is not associated with, or cannot view any Organizations.
        </li>
        <li>Organizations visible to you may already be associated with a different Rackspace account.</li>
      </ul>
      <hr />
      <p className="mt-4">If you expected to see a specific organization, please try the following:</p>
      <ul>
        <li>Work with your Administrator to ensure you have sufficient permissions on your Organization (e.g. Organization Admin).</li>
        <li><Button onClick={handleLogout} size="md" variant="link" className="p-0">Sign in with a different Google account.</Button></li>
        <li><ExternalLink href="https://support.google.com/cloudidentity/answer/7389973">Create a Google Organization.</ExternalLink></li>
      </ul>
      <p>
        <small>
          For additional assistance, please reach out to your Rackspace Technical Onboarding Manager (TOM).
        </small>
      </p>
    </Alert>
  );
};

export default OrganizationsAbsent;
